module.exports = __webpack_public_path__ + "static/media/obstetrica.21c287ea.svg";